export default "/images/vendor/flag-icon-css/flags/4x3/tl.svg?503b7926732b784efbede0c1d6569df2";